import { Link } from '@tanstack/react-router';
import { Tooltip, TooltipContent, TooltipTrigger } from 'cpool-components/general/Tooltip';
import { Truncate } from 'cpool-components/general/Truncate';
import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetUnreadConsorsNotes } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';
import { LuEye } from 'react-icons/lu';

import { getNotificationLinkOptions } from '~/features/notifications/utils/getNotificationLinkOptions';
import { dateFormat, timeFormat } from '~/lib/i18n';

type Props = {
    data: SchemaLoanRequestResolver_GetUnreadConsorsNotes[number];
};

export const BankReportItem: React.FC<Props> = ({ data }) => {
    const { t } = useTranslation();

    const createdAtDate = new Date(data.createdAt);
    const createdAt = `${dateFormat(createdAtDate)} - ${timeFormat(createdAtDate)}`;

    return (
        <Link
            {...getNotificationLinkOptions(PROCESSED_NOTIFICATION_KINDS.BANK_REPORT, data.loanRequestId)}
            target="_blank"
        >
            <div className="hover:bg-surface-light py-2 px-4 flex items-center justify-between gap-2 rounded-md">
                <div className="flex items-center gap-2 min-w-[200px] max-w-[313px]">
                    <div>
                        <Truncate maxWidth="200px" className="mb-1 text-sm text-midnight min-w-[200px] max-w-[200px]">
                            {data.antragsteller1.personendaten?.vorname} {data.antragsteller1.personendaten?.nachname}
                        </Truncate>
                        <p className="text-xs text-midnight-placeholder">
                            <span>{createdAt}</span> {t('DASHBOARD.BANKREPORTS.DATE')}
                        </p>
                    </div>
                    {data.notes[0] && (
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Truncate maxWidth="160px" className="text-sm font-medium text-midnight max-w-[160px]">
                                    {data.notes[0].data.content}
                                </Truncate>
                            </TooltipTrigger>
                            <TooltipContent side="top" sideOffset={6}>
                                <ul className="flex flex-col gap-1 list-disc pl-4">
                                    {data.notes.map((note) => (
                                        <li key={note.data.id}>{note.data.content}</li>
                                    ))}
                                </ul>
                            </TooltipContent>
                        </Tooltip>
                    )}
                </div>
                <Button variant={ButtonVariant.SECONDARY} iconLeft={<LuEye />}>
                    {t('DASHBOARD.BANKREPORTS.CHECKOUT')}
                </Button>
            </div>
        </Link>
    );
};
